import axios from "axios";
import {
  AVAILABILITY_REQUEST,
  AVAILABILITY_SUCCESS,
  AVAILABILITY_FAIL,
  RESERVATION_CREATE_REQUEST,
  RESERVATION_CREATE_SUCCESS,
  RESERVATION_CREATE_FAIL,
  EVENTS_LIST_REQUEST,
  EVENTS_LIST_SUCCESS,
  EVENTS_LIST_FAIL,
  EVENT_DETAILS_REQUEST,
  EVENT_DETAILS_SUCCESS,
  EVENT_DETAILS_FAIL,
  EVENT_RESERVE_REQUEST,
  EVENT_RESERVE_SUCCESS,
  EVENT_RESERVE_FAIL,
  RESERVATION_LOOKUP_REQUEST,
  RESERVATION_LOOKUP_SUCCESS,
  RESERVATION_LOOKUP_FAIL,
  RESERVATION_CANCEL_REQUEST,
  RESERVATION_CANCEL_SUCCESS,
  RESERVATION_CANCEL_FAIL,
} from "../constants/reservationConstants";

export const getAvailability = (date, partySize) => async (dispatch) => {
  try {
    dispatch({ type: AVAILABILITY_REQUEST });

    const { data } = await axios.get(
      `/api/reservations/availability/?date=${date}&party_size=${partySize}`,
    );

    dispatch({ type: AVAILABILITY_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: AVAILABILITY_FAIL,
      payload: error.response?.data?.detail || "Nem sikerült betölteni a szabad időpontokat.",
    });
  }
};

export const createReservation = (payload) => async (dispatch) => {
  try {
    dispatch({ type: RESERVATION_CREATE_REQUEST });

    const { data } = await axios.post("/api/reservations/create/", payload);

    dispatch({ type: RESERVATION_CREATE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: RESERVATION_CREATE_FAIL,
      payload: error.response?.data?.detail || "A foglalás nem sikerült.",
    });
    throw error;
  }
};

export const listEvents = () => async (dispatch) => {
  try {
    dispatch({ type: EVENTS_LIST_REQUEST });

    const { data } = await axios.get("/api/events/");

    dispatch({ type: EVENTS_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: EVENTS_LIST_FAIL,
      payload: error.response?.data?.detail || "Nem sikerült betölteni az eseményeket.",
    });
  }
};

export const getEventDetails = (slug) => async (dispatch) => {
  try {
    dispatch({ type: EVENT_DETAILS_REQUEST });

    const { data } = await axios.get(`/api/events/${slug}/`);

    dispatch({ type: EVENT_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: EVENT_DETAILS_FAIL,
      payload: error.response?.data?.detail || "Az esemény nem található.",
    });
  }
};

export const reserveEvent = (slug, payload) => async (dispatch) => {
  try {
    dispatch({ type: EVENT_RESERVE_REQUEST });

    const { data } = await axios.post(`/api/events/${slug}/reserve/`, payload);

    dispatch({ type: EVENT_RESERVE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: EVENT_RESERVE_FAIL,
      payload: error.response?.data?.detail || "A foglalás nem sikerült.",
    });
    throw error;
  }
};

export const getReservationByToken = (token) => async (dispatch) => {
  try {
    dispatch({ type: RESERVATION_LOOKUP_REQUEST });

    const { data } = await axios.get(`/api/reservations/${token}/`);

    dispatch({ type: RESERVATION_LOOKUP_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: RESERVATION_LOOKUP_FAIL,
      payload: error.response?.data?.detail || "A foglalás nem található.",
    });
  }
};

export const cancelReservationByToken = (token) => async (dispatch) => {
  try {
    dispatch({ type: RESERVATION_CANCEL_REQUEST });

    const { data } = await axios.post(`/api/reservations/${token}/cancel/`);

    dispatch({ type: RESERVATION_CANCEL_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: RESERVATION_CANCEL_FAIL,
      payload: error.response?.data?.detail || "A lemondás nem sikerült.",
    });
    throw error;
  }
};
